/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Trophy(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M232,64H208V56a16.01833,16.01833,0,0,0-16-16H64A16.01833,16.01833,0,0,0,48,56v8H23.87305a16.01833,16.01833,0,0,0-16,16V96a40.04583,40.04583,0,0,0,40,40H51.917c9.64258,29.93658,36.14258,52.34668,68.083,55.58276V216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V191.60626A80.12,80.12,0,0,0,204.34521,136H208a40.04584,40.04584,0,0,0,40-40V80A16.01833,16.01833,0,0,0,232,64ZM47.87305,120a24.0275,24.0275,0,0,1-24-24V80H48v31.0957A81.777,81.777,0,0,0,48.499,120ZM232,96a24.0275,24.0275,0,0,1-24,24h-.39209q.39037-3.96176.39209-8V80h24Z" />
    </Svg>
  );
}

export default Trophy;
